import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { type CatalogValue } from '../../models/Catalog';

import { CatalogValueEdit } from './CatalogValueEdit';
import { CatalogValueList } from './CatalogValueList';

type ViewMode = 'list' | 'create' | 'edit';

export const CatalogValuePage = () => {
  // se recupera el identificador del catalogo que se lista
  const { id } = useParams();

  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selected, setSelected] = useState<CatalogValue | undefined>();

  const handleCreate = () => {
    setViewMode('edit');
  };

  const handleEdit = (row: CatalogValue) => {
    setSelected(row);
    setViewMode('edit');
  };

  const handleCancel = () => {
    setSelected(undefined);
    setViewMode('list');
  };

  const handleFinish = () => {
    setSelected(undefined);
    setViewMode('list');

    // se vuelve cargar la lista para refrescar la información
    // refetch();
  };

  return (
    <>
      {viewMode == 'edit' && (
        <CatalogValueEdit
          catalogId={id!}
          handleCancel={handleCancel}
          handleFinish={handleFinish}
          original={selected}
        />
      )}

      {viewMode == 'list' && (
        <CatalogValueList id={id!} handleEdit={handleEdit} handleCreate={handleCreate} />
      )}
    </>
  );
};
